import React from "react";
import "./PrimaryButton.css";

const PrimaryButton = ({
  isLoading = false,
  disabled = false,
  className = "",
  onClick,
  text,
  style = {},
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isLoading || disabled}
      className="primary-button-container"
      style={style}
    >
      {isLoading ? <span>Загрузка...</span> : text}
    </button>
  );
};

export default PrimaryButton;
